import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectFilledPhotoById } from '../_redux-photos';

// TODO Refactor this out, use idiomatic component-specific connectors
interface MemoizedPhoto {
  id: string;
  groupId: string;
  crop: PhotoPrintsJson.ProcessedPhoto['crop'];
  filter: PhotoPrintsJson.ProcessedPhoto['filter'];
  reproString: PhotoPrintsJson.ProcessedPhoto['reproString'];
  magicBorderRngSeed: PhotoPrintsJson.ProcessedPhoto['magicBorderRngSeed'];
  status: PhotoPrintsJson.ProcessedPhoto['status'];
  quantity: PhotoPrintsJson.ProcessedPhoto['quantity'];
  assetId: PhotoPrintsJson.ProcessedPhoto['assetId'];
  processed: PhotoPrintsJson.ProcessedPhoto['processed'];
}

const createPhotoSelector = (photoId: string) =>
  createSelector(
    [(state: PhotoPrintsPdpState) => selectFilledPhotoById(state, photoId)],
    (photo: PhotoPrintsJson.ProcessedPhoto): MemoizedPhoto => ({
      id: photo.id,
      groupId: photo.groupId,
      // Only include properties that affect rendering
      crop: photo.crop,
      filter: photo.filter,
      reproString: photo.reproString,
      magicBorderRngSeed: photo.magicBorderRngSeed,
      // Include other necessary properties
      status: photo.status,
      quantity: photo.quantity,
      assetId: photo.assetId,
      processed: photo.processed
    })
  );

export const useMemoizedPhoto = (photoId: string) => {

  const selector = useMemo(() => createPhotoSelector(photoId), [photoId]);

  return useSelector(selector, shallowEqual);
};